import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const templateCategoryApi = createApi({
  reducerPath: 'templateCategoryApi',
  baseQuery: rtkBaseQuery('/claim/TemplateCategory'),
  tagTypes: ['TemplateCategory'],
  endpoints: (builder) => ({
    getAllTemplatesCategory: builder.query({
      query: () => '/GetAll',
      providesTags: ['TemplateCategory'],
    }),
    getFilteredTemplatesCategory: builder.query({
      query: () => '/GetAll?all=false',
      providesTags: ['TemplateCategory'],
    }),
    getTemplateCategoryById: builder.query({
      query: ({ id }) => `/GetById?id=${id}`,
    }),
    createTemplatesCategory: builder.mutation({
      query: (body) => ({
        url: '/Create',
        method: 'POST',
        responseHandler: (response) => response.text(),
        body,
      }),
      invalidatesTags: ['TemplateCategory'],
    }),
    updateTemplatesCategory: builder.mutation({
      query: ({ id, body }) => ({
        url: `/Update?id=${id}`,
        method: 'PUT',
        responseHandler: (response) => response.text(),
        body,
      }),
    }),
    deleteTemplatesCategory: builder.mutation({
      query: (id) => ({
        url: `/Delete?id=${id}`,
        method: 'DELETE',
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useGetAllTemplatesCategoryQuery,
  useGetFilteredTemplatesCategoryQuery,
  useGetTemplateCategoryByIdQuery,
  useCreateTemplatesCategoryMutation,
  useUpdateTemplatesCategoryMutation,
  useDeleteTemplatesCategoryMutation,
} = templateCategoryApi;
